<template>
    <div class="footerPage">
      <!-- 返回顶部 -->
      <div class="backTop flex-rowc" @click="backTop">Back to Top</div>
      <div class="copy"></div>
    </div>
  </template>
  <script>
  export default {
    name: "myFooter",
    data() {
      return {};
    },
    mounted() {},
    methods: {
      backTop() {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }
    },
  };
  </script>
  <style scoped lang="less">
  .footerPage {
    .backTop {
      height: 60px;
      background: #434e5a;
      font-size: 18px;
      color: #FFFFFF;
      cursor: pointer;
    }
    .footer {
      height: 600px;
      background: url("../assets/images/footer_bg.jpg") no-repeat center;
      background-size: cover;
    }
    .copy {
      height: 30px;
      background: #383C3F;
    }
  }
  </style>